import { KPIMetrics, Team, Employee, BacklogData } from '../types';

export const mockKPIMetrics: KPIMetrics = {
  budgetTotalMonth: 3875000,
  budgetAsOfYesterday: 1660000,
  actualAsOfYesterday: 1880000,
  billableRateSoFar: 46,
  budgetBillableRate: 47,
  expectedTotalHours: 2548,
  loggedTotalHours: 2910,
  absence: 214,
  vacation: 488,
};

export const mockTeams: Team[] = [
  {
    id: '1',
    name: 'Maco',
    budgetYesterday: 42700,
    loggedYesterday: 22800,
    totalBudget: 0,
  },
  {
    id: '2',
    name: 'Operations',
    budgetYesterday: 101500,
    loggedYesterday: 189900,
    totalBudget: 243900,
  },
  {
    id: '3',
    name: 'Team 1',
    budgetYesterday: 75000,
    loggedYesterday: 82000,
    totalBudget: 180000,
  },
  {
    id: '4',
    name: 'Team 2',
    budgetYesterday: 65000,
    loggedYesterday: 71000,
    totalBudget: 150000,
  },
  {
    id: '5',
    name: 'Team 3',
    budgetYesterday: 55000,
    loggedYesterday: 60000,
    totalBudget: 120000,
  },
  {
    id: '6',
    name: 'Tech Board',
    budgetYesterday: 45000,
    loggedYesterday: 48000,
    totalBudget: 100000,
  },
];

export const mockDesignTeams: string[] = [
  'Maco',
  'Tech board',
  'Team Litium',
  'Team 1',
  'Team 2',
  'Operations',
];

export const mockEmployeesTable = [
  {
    employee: 'Aleksandar Atlagic',
    billableRate: 70,
    billableHrsAOY: 39,
    hoursLogged: 41,
    billableTotal: 119820,
    billableNOKAOY: 77815,
    billableRateAOY: 0.65,
    clientHoursAOY: 25,
    billableAmountAOY: 65000,
    missingLoggedHours: 2,
    thisWeek: 75,
    nextWeek: 80,
    in2Weeks: 70,
    in3Weeks: 65,
  },
  {
    employee: 'Joachim Strand',
    billableRate: 65,
    billableHrsAOY: 42,
    hoursLogged: 38,
    billableTotal: 109200,
    billableNOKAOY: 72000,
    billableRateAOY: 0.60,
    clientHoursAOY: 25,
    billableAmountAOY: 60000,
    missingLoggedHours: -4,
    thisWeek: 70,
    nextWeek: 75,
    in2Weeks: 65,
    in3Weeks: 60,
  },
  {
    employee: 'Anders Rolland',
    billableRate: 75,
    billableHrsAOY: 13,
    hoursLogged: 10,
    billableTotal: 128378,
    billableNOKAOY: 16969,
    billableRateAOY: 0.28,
    clientHoursAOY: 11,
    billableAmountAOY: 15000,
    missingLoggedHours: -3,
    thisWeek: 60,
    nextWeek: 65,
    in2Weeks: 70,
    in3Weeks: 75,
  },
  {
    employee: 'Björn Edvard Jes...',
    billableRate: 75,
    billableHrsAOY: 41,
    hoursLogged: 45,
    billableTotal: 128378,
    billableNOKAOY: 52231,
    billableRateAOY: 0.53,
    clientHoursAOY: 39,
    billableAmountAOY: 52000,
    missingLoggedHours: 4,
    thisWeek: 80,
    nextWeek: 85,
    in2Weeks: 80,
    in3Weeks: 75,
  },
  {
    employee: 'Bojan Bubanja',
    billableRate: 10,
    billableHrsAOY: 3,
    hoursLogged: 2,
    billableTotal: 17117,
    billableNOKAOY: 0,
    billableRateAOY: 0.0,
    clientHoursAOY: 0,
    billableAmountAOY: 0,
    missingLoggedHours: -1,
    thisWeek: 5,
    nextWeek: 8,
    in2Weeks: 10,
    in3Weeks: 12,
  },
  {
    employee: 'Caroline Christia...',
    billableRate: 50,
    billableHrsAOY: 31,
    hoursLogged: 27,
    billableTotal: 77027,
    billableNOKAOY: 0,
    billableRateAOY: 0.24,
    clientHoursAOY: 0,
    billableAmountAOY: 0,
    missingLoggedHours: -4,
    thisWeek: 45,
    nextWeek: 50,
    in2Weeks: 55,
    in3Weeks: 60,
  },
  {
    employee: 'Dag Henrik Søren...',
    billableRate: 80,
    billableHrsAOY: 20,
    hoursLogged: 20,
    billableTotal: 123243,
    billableNOKAOY: 29930,
    billableRateAOY: 0.56,
    clientHoursAOY: 20,
    billableAmountAOY: 30000,
    missingLoggedHours: 0,
    thisWeek: 85,
    nextWeek: 90,
    in2Weeks: 85,
    in3Weeks: 80,
  },
  {
    employee: 'Damir Calusic',
    billableRate: 40,
    billableHrsAOY: 50,
    hoursLogged: 47,
    billableTotal: 136937,
    billableNOKAOY: 43306,
    billableRateAOY: 0.95,
    clientHoursAOY: 25,
    billableAmountAOY: 43000,
    missingLoggedHours: -3,
    thisWeek: 35,
    nextWeek: 40,
    in2Weeks: 45,
    in3Weeks: 50,
  },
  {
    employee: 'Dominykas Geluc...',
    billableRate: 0,
    billableHrsAOY: 0,
    hoursLogged: 0,
    billableTotal: 0,
    billableNOKAOY: 0,
    billableRateAOY: 0.0,
    clientHoursAOY: 0,
    billableAmountAOY: 0,
    missingLoggedHours: 0,
    thisWeek: 0,
    nextWeek: 0,
    in2Weeks: 0,
    in3Weeks: 0,
  },
  {
    employee: 'Einar Hovden',
    billableRate: 75,
    billableHrsAOY: 40,
    hoursLogged: 44,
    billableTotal: 131250,
    billableNOKAOY: 45625,
    billableRateAOY: 0.55,
    clientHoursAOY: 38,
    billableAmountAOY: 46000,
    missingLoggedHours: 4,
    thisWeek: 80,
    nextWeek: 85,
    in2Weeks: 80,
    in3Weeks: 75,
  },
  {
    employee: 'Eirik Hovden',
    billableRate: 70,
    billableHrsAOY: 35,
    hoursLogged: 34,
    billableTotal: 122500,
    billableNOKAOY: 40000,
    billableRateAOY: 0.50,
    clientHoursAOY: 32,
    billableAmountAOY: 40000,
    missingLoggedHours: -1,
    thisWeek: 75,
    nextWeek: 80,
    in2Weeks: 75,
    in3Weeks: 70,
  },
  {
    employee: 'Erik Johansen',
    billableRate: 65,
    billableHrsAOY: 38,
    hoursLogged: 38,
    billableTotal: 118300,
    billableNOKAOY: 35000,
    billableRateAOY: 0.45,
    clientHoursAOY: 35,
    billableAmountAOY: 35000,
    missingLoggedHours: 0,
    thisWeek: 70,
    nextWeek: 75,
    in2Weeks: 70,
    in3Weeks: 65,
  },
  {
    employee: 'Fredrik Hansen',
    billableRate: 80,
    billableHrsAOY: 42,
    hoursLogged: 46,
    billableTotal: 134400,
    billableNOKAOY: 48000,
    billableRateAOY: 0.60,
    clientHoursAOY: 40,
    billableAmountAOY: 48000,
    missingLoggedHours: 4,
    thisWeek: 85,
    nextWeek: 90,
    in2Weeks: 85,
    in3Weeks: 80,
  },
  {
    employee: 'Gustav Olsen',
    billableRate: 70,
    billableHrsAOY: 36,
    hoursLogged: 32,
    billableTotal: 126000,
    billableNOKAOY: 42000,
    billableRateAOY: 0.55,
    clientHoursAOY: 33,
    billableAmountAOY: 42000,
    missingLoggedHours: -4,
    thisWeek: 75,
    nextWeek: 80,
    in2Weeks: 75,
    in3Weeks: 70,
  },
  {
    employee: 'Håkon Berg',
    billableRate: 75,
    billableHrsAOY: 39,
    hoursLogged: 39,
    billableTotal: 131250,
    billableNOKAOY: 45000,
    billableRateAOY: 0.58,
    clientHoursAOY: 36,
    billableAmountAOY: 45000,
    missingLoggedHours: 0,
    thisWeek: 80,
    nextWeek: 85,
    in2Weeks: 80,
    in3Weeks: 75,
  },
  {
    employee: 'Ivar Nilsen',
    billableRate: 65,
    billableHrsAOY: 34,
    hoursLogged: 31,
    billableTotal: 119000,
    billableNOKAOY: 38000,
    billableRateAOY: 0.48,
    clientHoursAOY: 31,
    billableAmountAOY: 38000,
    missingLoggedHours: -3,
    thisWeek: 70,
    nextWeek: 75,
    in2Weeks: 70,
    in3Weeks: 65,
  },
  {
    employee: 'Johan Pedersen',
    billableRate: 80,
    billableHrsAOY: 41,
    hoursLogged: 41,
    billableTotal: 131200,
    billableNOKAOY: 47000,
    billableRateAOY: 0.62,
    clientHoursAOY: 39,
    billableAmountAOY: 47000,
    missingLoggedHours: 0,
    thisWeek: 85,
    nextWeek: 90,
    in2Weeks: 85,
    in3Weeks: 80,
  },
  {
    employee: 'Kristian Svendsen',
    billableRate: 70,
    billableHrsAOY: 37,
    hoursLogged: 39,
    billableTotal: 129500,
    billableNOKAOY: 41000,
    billableRateAOY: 0.53,
    clientHoursAOY: 34,
    billableAmountAOY: 41000,
    missingLoggedHours: 2,
    thisWeek: 75,
    nextWeek: 80,
    in2Weeks: 75,
    in3Weeks: 70,
  },
];

export const mockEmployees: Employee[] = [
  {
    name: 'Aleksandar Atlagic',
    billableRate: 70,
    clientHours: 39,
    billableTotal: 119820,
    billableRateAOY: 63,
    clientHoursAOY: 48,
    billableAmountAOY: 77815,
    thisWeek: 77,
    nextWeek: 67,
    in2Weeks: 16,
    in3Weeks: 0,
  },
  {
    name: 'Joachim Strand',
    billableRate: 65,
    clientHours: 42,
    billableTotal: 109200,
    billableRateAOY: 60,
    clientHoursAOY: 45,
    billableAmountAOY: 72000,
    thisWeek: 80,
    nextWeek: 75,
    in2Weeks: 20,
    in3Weeks: 15,
  },
  {
    name: 'Anders Rolland',
    billableRate: 75,
    clientHours: 13,
    billableTotal: 128378,
    billableRateAOY: 28,
    clientHoursAOY: 11,
    billableAmountAOY: 16969,
    thisWeek: 0,
    nextWeek: 59,
    in2Weeks: 40,
    in3Weeks: 51,
  },
  {
    name: 'Björn Edvard Jes...',
    billableRate: 75,
    clientHours: 41,
    billableTotal: 128378,
    billableRateAOY: 53,
    clientHoursAOY: 39,
    billableAmountAOY: 52231,
    thisWeek: 51,
    nextWeek: 45,
    in2Weeks: 51,
    in3Weeks: 45,
  },
  {
    name: 'Bojan Bubanja',
    billableRate: 10,
    clientHours: 3,
    billableTotal: 17117,
    billableRateAOY: 0,
    clientHoursAOY: 0,
    billableAmountAOY: 0,
    thisWeek: 0,
    nextWeek: 0,
    in2Weeks: 0,
    in3Weeks: 0,
  },
  {
    name: 'Caroline Christia...',
    billableRate: 50,
    clientHours: 31,
    billableTotal: 77027,
    billableRateAOY: 24,
    clientHoursAOY: 0,
    billableAmountAOY: 0,
    thisWeek: 49,
    nextWeek: 40,
    in2Weeks: 47,
    in3Weeks: 59,
  },
  {
    name: 'Dag Henrik Søren...',
    billableRate: 80,
    clientHours: 20,
    billableTotal: 123243,
    billableRateAOY: 56,
    clientHoursAOY: 20,
    billableAmountAOY: 29930,
    thisWeek: 60,
    nextWeek: 67,
    in2Weeks: 65,
    in3Weeks: 59,
  },
  {
    name: 'Damir Calusic',
    billableRate: 40,
    clientHours: 50,
    billableTotal: 136937,
    billableRateAOY: 95,
    clientHoursAOY: 25,
    billableAmountAOY: 43306,
    thisWeek: 45,
    nextWeek: 44,
    in2Weeks: 55,
    in3Weeks: 73,
  },
  {
    name: 'Dominykas Geluc...',
    billableRate: 0,
    clientHours: 0,
    billableTotal: 0,
    billableRateAOY: 0,
    clientHoursAOY: 0,
    billableAmountAOY: 0,
    thisWeek: 0,
    nextWeek: 0,
    in2Weeks: 0,
    in3Weeks: 0,
  },
  {
    name: 'Einar Hovden',
    billableRate: 75,
    clientHours: 40,
    billableTotal: 131250,
    billableRateAOY: 55,
    clientHoursAOY: 38,
    billableAmountAOY: 45625,
    thisWeek: 65,
    nextWeek: 70,
    in2Weeks: 68,
    in3Weeks: 72,
  },
  {
    name: 'Eirik Hovden',
    billableRate: 70,
    clientHours: 35,
    billableTotal: 122500,
    billableRateAOY: 50,
    clientHoursAOY: 32,
    billableAmountAOY: 40000,
    thisWeek: 60,
    nextWeek: 65,
    in2Weeks: 62,
    in3Weeks: 68,
  },
  {
    name: 'Erik Johansen',
    billableRate: 65,
    clientHours: 38,
    billableTotal: 118300,
    billableRateAOY: 45,
    clientHoursAOY: 35,
    billableAmountAOY: 35000,
    thisWeek: 55,
    nextWeek: 60,
    in2Weeks: 58,
    in3Weeks: 65,
  },
  {
    name: 'Fredrik Hansen',
    billableRate: 80,
    clientHours: 42,
    billableTotal: 134400,
    billableRateAOY: 60,
    clientHoursAOY: 40,
    billableAmountAOY: 48000,
    thisWeek: 70,
    nextWeek: 75,
    in2Weeks: 72,
    in3Weeks: 78,
  },
  {
    name: 'Gustav Olsen',
    billableRate: 70,
    clientHours: 36,
    billableTotal: 126000,
    billableRateAOY: 55,
    clientHoursAOY: 33,
    billableAmountAOY: 42000,
    thisWeek: 62,
    nextWeek: 67,
    in2Weeks: 64,
    in3Weeks: 69,
  },
  {
    name: 'Håkon Berg',
    billableRate: 75,
    clientHours: 39,
    billableTotal: 131250,
    billableRateAOY: 58,
    clientHoursAOY: 36,
    billableAmountAOY: 45000,
    thisWeek: 68,
    nextWeek: 73,
    in2Weeks: 70,
    in3Weeks: 75,
  },
  {
    name: 'Ivar Nilsen',
    billableRate: 65,
    clientHours: 34,
    billableTotal: 119000,
    billableRateAOY: 48,
    clientHoursAOY: 31,
    billableAmountAOY: 38000,
    thisWeek: 58,
    nextWeek: 63,
    in2Weeks: 60,
    in3Weeks: 65,
  },
  {
    name: 'Johan Pedersen',
    billableRate: 80,
    clientHours: 41,
    billableTotal: 131200,
    billableRateAOY: 62,
    clientHoursAOY: 39,
    billableAmountAOY: 47000,
    thisWeek: 72,
    nextWeek: 77,
    in2Weeks: 74,
    in3Weeks: 79,
  },
  {
    name: 'Kristian Svendsen',
    billableRate: 70,
    clientHours: 37,
    billableTotal: 129500,
    billableRateAOY: 53,
    clientHoursAOY: 34,
    billableAmountAOY: 41000,
    thisWeek: 64,
    nextWeek: 69,
    in2Weeks: 66,
    in3Weeks: 71,
  },
];

export const mockBacklogData: BacklogData[] = [
  {
    team: 'Operations',
    thisWeek: 0,
    nextWeek: 0,
    in2Weeks: 0,
    in3Weeks: 0,
  },
  {
    team: 'Team 1',
    thisWeek: 40,
    nextWeek: 52,
    in2Weeks: 41,
    in3Weeks: 26,
  },
  {
    team: 'Team 2',
    thisWeek: 35,
    nextWeek: 45,
    in2Weeks: 38,
    in3Weeks: 22,
  },
  {
    team: 'Team 3',
    thisWeek: 30,
    nextWeek: 40,
    in2Weeks: 35,
    in3Weeks: 20,
  },
  {
    team: 'Maco',
    thisWeek: 25,
    nextWeek: 35,
    in2Weeks: 30,
    in3Weeks: 18,
  },
  {
    team: 'Tech Board',
    thisWeek: 20,
    nextWeek: 30,
    in2Weeks: 25,
    in3Weeks: 15,
  },
];

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('no-NO', {
    style: 'currency',
    currency: 'NOK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const getPerformanceColor = (percentage: number): string => {
  if (percentage >= 100) return 'text-green-600';
  if (percentage >= 80) return 'text-yellow-600';
  return 'text-red-600';
};
